import dayjs from 'dayjs'
import { centsToDollarsDisplay } from '../../displayFormatters'
import { BatchJobStatus, BatchStatus } from '../../../domain/invoicing/invoicingApi'
import { JobForInvoicing } from '../../../domain/invoicing/invoice'
import { workAreaStatusName, workAreaStatusNames } from '../workAreaStatusModel'

export const INTERVAL_ONLY_BATCH_TOOLTIP =
  "Interval billing isn't supported in Batch Create yet — invoice individually"

export const isIntervalOnlyJob = (job: JobForInvoicing): boolean =>
  job.hasIntervalPaymentDue && !job.canBatchInvoice

export const isBatchProcessing = (status: string | undefined) =>
  status === 'pending' || status === 'processing'

export const isBatchDone = (status: string | undefined) =>
  status === 'completed' || status === 'failed'

export const calculateBatchProgress = (completedJobs: number, skippedJobs: number, failedJobs: number, totalJobs: number) =>
  totalJobs > 0 ? Math.round(((completedJobs + skippedJobs + failedJobs) / totalJobs) * 100) : 0

export const calculateDefaultDueDate = (defaultDueInDays: number): string => {
  return dayjs().add(defaultDueInDays, 'day').format('YYYY-MM-DD')
}

export const quotedWorkSummary = (quotedRemainingAmount: number, quotedCompletedDate: string): string => {
  const amount = centsToDollarsDisplay(quotedRemainingAmount) ?? ''
  if (quotedCompletedDate) {
    return `${amount} · completed ${quotedCompletedDate}`
  }
  return amount
}

export const mapWorkAreaStatus = workAreaStatusName

export const mapWorkAreaStatuses = workAreaStatusNames

export const batchStatusConfig: Record<BatchStatus['status'], { color: string, label: string }> = {
  pending: { color: 'default', label: 'Pending' },
  processing: { color: 'processing', label: 'Processing' },
  completed: { color: 'success', label: 'Completed' },
  failed: { color: 'error', label: 'Failed' },
}

export const jobStatusConfig: Record<BatchJobStatus['status'], { color: string, label: string }> = {
  'not-started': { color: 'default', label: 'Not Started' },
  'in-progress': { color: 'processing', label: 'In Progress' },
  completed: { color: 'success', label: 'Completed' },
  skipped: { color: 'warning', label: 'Skipped' },
  failed: { color: 'error', label: 'Failed' },
}
